import PrinterSummationPage from '@pages/printerSummation/PrinterSummation.page';
import ProgressPage from '@pages/progress/Progress.page';
import ScannerPage from '@pages/scanner/Scanner.page';

export const routes = [
  {
    path: '/',
    Component: ScannerPage,
  },
  {
    path: '/progress',
    Component: ProgressPage,
  },
  {
    path: '/printer/:printerId',
    Component: PrinterSummationPage,
  },
];
